import { Module } from 'vuex';
import { RootState } from '@/app/app.store';
import {
  authLoginStoreModule,
  AuthLoginStoreState,
} from './login/auth-login.store';
import { apiHttpClient, parseJwt } from '../app/app.service';

export interface AuthStoreState {
  login: AuthLoginStoreState;
  token: {
    refreshToken: {
      token: string;
      expiresIn: number;
    };
    accessToken: {
      token: string;
      expiresIn: number;
    };
  } | null;
}

export const authStoreModule: Module<AuthStoreState, RootState> = {
  /**
   * 命名空间
   */
  namespaced: true,

  /**
   * 数据
   */
  state: {
    token: null,
  } as AuthStoreState,

  /**
   * 获取器
   */
  getters: {
    isLoggedIn(state) {
      return state.token ? true : false;
    },

    token(state) {
      return state.token;
    },

    accessToken(state) {
      return state.token?.accessToken.token;
    },

    refreshToken(state) {
      return state.token?.refreshToken.token;
    },

    isAccessTokenExpired(state) {
      if (state.token) {
        const now = Math.round(Date.now() / 1000);
        return now >= state.token?.accessToken.expiresIn;
      }

      return false;
    },

    isRefreshTokenExpired(state) {
      if (state.token) {
        const now = Math.round(Date.now() / 1000);
        return now >= state.token?.refreshToken.expiresIn;
      }

      return false;
    },
  },

  /**
   * 修改器
   */
  mutations: {
    setToken(state, data) {
      if (data == null) {
        state.token = null;
      } else {
        const { refreshToken, accessToken } = data;
        const refreshTokenPayload = parseJwt(refreshToken);
        const accessTokenPayload = parseJwt(accessToken);

        if (refreshTokenPayload && accessTokenPayload) {
          state.token = {
            refreshToken: {
              token: refreshToken,
              expiresIn: refreshTokenPayload.exp,
            },
            accessToken: {
              token: accessToken,
              expiresIn: accessTokenPayload.exp,
            },
          };
        }
      }
    },
  },

  /**
   * 动作
   */
  actions: {
    configApiHttpClientAuthHeader(_, data) {
      apiHttpClient.defaults.headers.common['Authorization'] = `Bearer ${data}`;
    },

    logout({ commit }) {
      commit('setToken', null);
      commit('user/setCurrentUser', null, { root: true });
      commit('auth/login/setLoginResponseData', null, { root: true });
      apiHttpClient.defaults.headers.common['Authorization'] = null;
    },
  },

  /**
   * 模块
   */
  modules: {
    login: authLoginStoreModule,
  },
};
